import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

class ConfirmSaveDialog extends React.Component {
  sendForm() {
    // tym tylko zamykam dialog potwierdzeni i otwieram nowy
    // poprzez zmiane 2-och pol w storze
    this.props.proceed("potwierdzono");
    // tym faktycznie wysylam
    this.props.realSendPoll(this.props.history, this.props.formValues);
  }
  render() {
    const { show, cancel } = this.props;
    return (
      <div className={show ? "modal is-active" : "modal"}>
        <div className="modal-background" />
        <div className="modal-content">
          <div className="box">
            <div className="content">
              <h3>Czy na pewno chcesz wysłać ankietę?</h3>
            </div>
            <div className="level">
              <div className="level-left">
                <div className="level-item">
                  <button
                    className="button is-medium "
                    onClick={() => cancel()}
                  >
                    Nie
                  </button>
                </div>
              </div>
              <div className="level-right">
                <div className="level-item">
                  <button
                    className="button is-link is-medium is-danger"
                    onClick={() => this.sendForm()}
                  >
                    Tak
                  </button>
                </div>
              </div>
            </div>
          </div>
          <button
            className="modal-close is-large"
            onClick={() => cancel("zamknieto okno")}
            aria-label="close"
          />
        </div>
      </div>
    );
  }
}

ConfirmSaveDialog.propTypes = {
  realSendPoll: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  cancel: PropTypes.func.isRequired,
  history: PropTypes.shape(),
  formValues: PropTypes.shape(),
  proceed: PropTypes.func.isRequired
};
ConfirmSaveDialog.defaultProps = {
  history: null,
  formValues: {}
};
export default withRouter(ConfirmSaveDialog);



// WEBPACK FOOTER //
// ./src/components/poll/ConfirmSaveDialog.js